import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
  overflow-x: clip;
`;

export const MainSection = styled.section`
  display: flex;
  box-sizing: border-box;
  padding: 52px 0 0 ${({ theme }) => theme.padding.medium};
  gap: 52px;
  position: relative;
  overflow: hidden;

  @media (max-width: 1600px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.large};
    padding: 52px ${({ theme }) => theme.padding.medium} 0;
  }
  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular} 0;
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.small} 0;
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    padding: 52px 0 0 ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.xlarge} 0 0
      ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: ${({ theme }) => theme.padding.xlarge} 0 0 1.5dvw;
  }
`;

export const TextFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 52px;
  width: 900px;
  box-sizing: border-box;

  @media (max-width: 1600px) {
    width: 100%;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 1500px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2200px) {
    width: 48dvw;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const TextLine = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xsmall};
  align-items: flex-start;
`;

export const DirectionsOfStudy = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1500px) {
    width: 900px;
  }
  @media (max-width: 930px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
`;

export const DirectionsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.small};
  width: 100%;

  @media (max-width: 930px) {
    justify-content: flex-start;
  }
  @media (min-width: 3000px) {
    gap: 16px;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3800px) {
    gap: 30px;
    justify-content: start;
  }
`;

export const DirectionOfStudy = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 26px;
  border-radius: 999px;
  border: 2px solid ${({ theme }) => theme.colors.darkBlue};
  text-wrap: nowrap;
  white-space: nowrap;
  text-align: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.small}
      ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3400px) {
    padding: 16px ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3800px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 4500px) {
    padding: ${({ theme }) => theme.padding.regular} 52px;
  }
`;

export const AccentCard = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.grey};

  span {
    display: flex;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.colors.green};
  }

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: flex-end;

    p {
      margin-bottom: ${({ theme }) => theme.spacing.regular};
    }
  }

  @media (min-width: 2500px) {
    span {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;
    padding: ${({ theme }) => theme.padding.medium};

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 54px;
      height: 54px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 4500px) {
    padding: 52px;
    gap: ${({ theme }) => theme.spacing.medium};

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 76px;
      height: 76px;
    }
  }
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;

  @media (max-width: 520px) {
    width: 100%;

    > button {
      width: 100%;
      inline-size: 100%;
      max-width: none;
      align-self: stretch;
    }

    > button > span:first-child {
      flex: 1;
    }
  }
`;

export const MainPictureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  justify-content: center;
  box-sizing: border-box;
  position: absolute;
  left: 60%;
  transform: translate(0, 20%);

  @media (max-width: 1600px) {
    position: relative;
    left: 0;
    transform: translate(0);
    align-items: center;
  }

  @media (min-width: 2200px) {
    transform: translate(0, 5%);
  }
  @media (min-width: 2500px) {
    transform: translate(0, 10%);
  }
  @media (min-width: 3000px) {
    transform: translate(0, 5%);
  }
  @media (min-width: 3300px) {
    transform: translate(0, 0);
    left: 56%;
    gap: 30px;
  }
  @media (min-width: 3400px) {
    left: 56%;
    gap: 30px;
  }
`;

export const MainPicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  border: 14px solid ${({ theme }) => theme.colors.darkBlue};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: #2a3f5f;
  box-shadow: ${({ theme }) => theme.shadow.medium};
  width: 856px;
  aspect-ratio: 856 / 480;
  overflow: hidden;

  img {
    position: absolute;
    right: 2px;
    display: block;
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    max-width: 96%;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (max-width: 520px) {
    border-width: 8px;
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }

  @media (min-width: 2200px) {
    width: 40dvw;
  }
  @media (min-width: 2500px) {
    width: 42dvw;
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3000px) {
    border: 0.75dvw solid ${({ theme }) => theme.colors.darkBlue};
  }
  @media (min-width: 3300px) {
    width: 40dvw;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  }
  @media (min-width: 3400px) {
    width: 44dvw;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  }
  @media (min-width: 3800px) {
    width: 46dvw;
  }
`;

export const MainTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 52px;

  @media (max-width: 1500px) {
    gap: ${({ theme }) => theme.spacing.medium};
    width: 100%;
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const MainCTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 52px;

  @media (max-width: 1600px) {
    justify-content: center;
  }
  @media (max-width: 1500px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const InfoSection = styled.section`
  display: flex;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium} 0;
  justify-content: center;

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular} 0;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge} 0 0;
  }

  @media (min-width: 2500px) {
    padding: 180px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3000px) {
    padding: 200px ${({ theme }) => theme.padding.large} 0;
  }
  @media (min-width: 3500px) {
    padding: 220px 1.5dvw 0;
  }
  @media (min-width: 3800px) {
    padding: 260px 1.5dvw 0;
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw 0;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.darkBlue};
  width: 85dvw;
  box-sizing: border-box;

  @media (max-width: 1600px) {
    width: 100%;
  }
  @media (max-width: 1280px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: 2500px) {
    padding: ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3800px) {
    padding: 52px;
  }
  @media (min-width: 4500px) {
    padding: 64px;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
    width: 86dvw;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  width: 425px;
  color: ${({ theme }) => theme.colors.offWhite};

  span {
    display: flex;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.colors.offWhite};
  }

  @media (max-width: 1280px) {
    width: 350px;
  }
  @media (max-width: 1024px) {
    width: 700px;
  }
  @media (max-width: 800px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    width: 24dvw;

    span {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.medium};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 54px;
      height: 54px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 4500px) {
    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 76px;
      height: 76px;
    }
  }
`;

export const InfoHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media (min-width: 2500px) {
    gap: 5px;
  }
  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const LetterSection = styled.section`
  display: flex;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium};
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 1500px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular};
  }
  @media (max-width: 930px) {
    flex-direction: column-reverse;
    align-items: center;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small};
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    padding: 200px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: 260px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 300px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw;
  }
`;

export const LetterOfRecognition = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.white};
  width: 481px;
  aspect-ratio: 481 / 714;
  overflow: hidden;
  cursor: zoom-in;

  img {
    position: absolute;
    right: 0;
    display: block;
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (max-width: 630px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    height: 40dvw;
    width: auto;
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  }
`;

export const LetterTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  align-self: center;
  width: 34dvw;
  max-width: 900px;
  box-sizing: border-box;

  @media (max-width: 1500px) {
    h2 {
      text-wrap: nowrap;
    }
  }
  @media (max-width: 1280px) {
    width: auto;
    max-width: 54dvw;
  }
  @media (max-width: 930px) {
    max-width: 100%;
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
    width: 100%;

    > button {
      width: 100%;
      inline-size: 100%;
      max-width: none;
      align-self: stretch;
    }

    > button > span:first-child {
      flex: 1;
    }
  }

  @media (min-width: 2500px) {
    width: 40dvw;
    max-width: 40dvw;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const LetterTextBlockInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const LetterStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const StatsCard = styled.div`
  display: flex;
  margin-top: 120px;
  margin-right: 40px;
  margin-bottom: -40px;
  z-index: 2;

  @media (min-width: 3000px) {
    margin-top: 180px;
    margin-right: 80px;
    margin-bottom: -80px;
  }
`;

export const IdtImage = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  background-color: ${({ theme }) => theme.colors.white};
  width: 222px;
  aspect-ratio: 222/326;
  overflow: hidden;

  img {
    position: absolute;
    right: 0;
    display: block;
    width: 100%;
    object-fit: contain;
  }

  @media (min-width: 2500px) {
    width: 10dvw;
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const LicenseSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.padding.xlarge}
    ${({ theme }) => theme.padding.medium};
  align-items: center;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular};
    border-radius: ${({ theme }) => theme.borderRadius.large};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 900px) {
    gap: ${({ theme }) => theme.spacing.xsmall};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.small};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  @media (min-width: 2500px) {
    padding: 100px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: 130px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 150px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 4dvw 1.5dvw;
  }
`;

export const LicenseInnerContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.large};

  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 980px) {
    h2 {
      font-size: 1.5rem;
    }
  }
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;

    h2 {
      font-size: 1.25rem;
    }
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const Licenses = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};

  @media (max-width: 630px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (max-width: 320px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const LicenseImage = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: 424px;
  aspect-ratio: 424 / 600;
  overflow: hidden;
  cursor: zoom-in;

  img {
    position: absolute;
    right: 0;
    display: block;
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 1280px) {
    width: 283px;
  }
  @media (max-width: 630px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    width: 22dvw;
  }
  @media (min-width: 3800px) {
    width: 26dvw;
  }
  @media (min-width: 4500px) {
    width: 24dvw;
  }
`;

export const LicenseTextBrake = styled.br`
  @media (max-width: 1280px) {
    display: none;
  }
  @media (max-width: 900px) {
    display: block;
  }
  @media (max-width: 520px) {
    display: none;
  }
`;

export const LicenseHeaderBrake = styled.br`
  @media (max-width: 900px) {
    display: none;
  }
`;

export const SertificateSection = styled.section`
  display: flex;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium};
  justify-content: center;

  @media (max-width: 1536px) {
    justify-content: space-between;
  }
  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular};
  }
  @media (max-width: 980px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
    align-items: center;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small};
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    padding: 200px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: 260px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 300px 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingTablet};
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingDesktop};
  }
`;

export const SertificateImage = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  width: 868px;
  aspect-ratio: 868 / 613;
  overflow: hidden;
  cursor: zoom-in;

  img {
    position: absolute;
    right: 0;
    display: block;
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 1280px) {
    width: 586px;
  }
  @media (max-width: 630px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    width: calc(44dvw + 20px);
  }
  @media (min-width: 3000px) {
    width: calc(44dvw + 24px);
  }
  @media (min-width: 3800px) {
    width: calc(52dvw + 40px);
  }
  @media (min-width: 4500px) {
    width: calc(48dvw + 40px);
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
  width: 564px;

  @media (max-width: 1536px) {
    width: auto;
  }
  @media (max-width: 980px) {
    align-items: center;
  }

  @media (min-width: 2500px) {
    width: 30dvw;
  }
  @media (min-width: 3000px) {
    width: 24dvw;
  }
  @media (min-width: 3400px) {
    width: 26.5dvw;
  }
`;

export const SectionHeadingCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
`;
